define('ServicesHelper',['require','exports','module','env'],function (require, exports, module) {
  "use strict";

  var Config = require("env");

  var ServicesHelper = {
    SERVICES_DICTIONARY: {
      MDirector: "email_marketing",
      Landings: "landing_optimizer",
      Transaccionales: "email_transactional",
      Automation: "marketing_automation",
      Payments: "payments",
      Integrations: "integrations",
    },

    getServicesAPIUrl: function () {
      return Config.backendUrl + "/my-services";
    },

    getServices: function () {
      return $.ajax({
        method: "get",
        dataType: "json",
        url: this.getServicesAPIUrl(),
        xhrFields: {
          withCredentials: true,
        },
        crossDomain: true,
        success: function (response) {
          if (!response._embedded || !response._embedded.services) {
            return;
          }
        }.bind(this),
        error: function (err) {
          console.log(err);
        },
      });
    },

    parseServices: function (services) {
      if (!services || !services.length) {
        return [];
      }

      var self = this;
      return services
        .map(function (service) {
          var name = self.SERVICES_DICTIONARY[service.service];
          if (!name) {
            return null;
          }
          service.service = name;
          return service;
        })
        .filter(function (service) {
          return service;
        });
    },
  };

  module.exports = ServicesHelper;
});

